import { useContext } from "react";
import { RecorderContext } from "./RecorderContext";


const useRecorderContext = () => {
    const context = useContext(RecorderContext);
    if (!context) {
        throw new Error("useRecorderContext must be used within a RecorderProvider");
    }
    return context;
};

export default useRecorderContext;